{
  "home.nav": "الرئيسية",
  "home.title": "الرئيسية",
  "home.greeting": "{greeting, select, morning {صباح الخير} afternoon {طاب يومك} other {مساء الخير}}، {name}",
  "home.subtitle": "إليك نظرة سريعة على سير العمل اليوم، {date}.",
  "home.loadError": "تعذّر تحميل صفحتك الرئيسية.",
  "home.portfolio.title": "المشاريع في لمحة",
  "home.portfolio.active": "مشاريع نشطة",
  "home.portfolio.onHold": "{count, plural, zero {لا مشاريع متوقفة} one {مشروع متوقف مؤقتاً} two {مشروعان متوقفان مؤقتاً} few {# مشاريع متوقفة مؤقتاً} many {# مشروعًا متوقفًا مؤقتاً} other {# مشروع متوقف مؤقتاً}}",
  "home.portfolio.open": "مهام مفتوحة",
  "home.portfolio.dueThisWeek": "{count, plural, zero {لا مواعيد تسليم هذا الأسبوع} one {موعد تسليم واحد هذا الأسبوع} two {موعدا تسليم هذا الأسبوع} few {# مواعيد تسليم هذا الأسبوع} many {# موعد تسليم هذا الأسبوع} other {# موعد تسليم هذا الأسبوع}}",
  "home.portfolio.overdue": "مهام متأخرة",
  "home.portfolio.done": "أُنجزت في ٧ أيام",
  "home.focus.title": "أولوياتك",
  "home.focus.open": "مهامي",
  "home.focus.overdue": "متأخرة",
  "home.focus.today": "اليوم",
  "home.focus.week": "هذا الأسبوع",
  "home.attention.title": "مشاريع تحتاج إلى انتباه",
  "home.attention.all": "كل المشاريع",
  "home.attention.lead": "قائد المشروع: {name}",
  "home.attention.healthy": "{count, plural, zero {لا مشاريع أخرى} one {مشروع آخر يسير وفق الخطة} two {مشروعان آخران يسيران وفق الخطة} few {# مشاريع أخرى تسير وفق الخطة} many {# مشروعًا آخر يسير وفق الخطة} other {# مشروع آخر يسير وفق الخطة}}",
  "home.attention.more": "{count, plural, zero {لا مشاريع أخرى تحتاج إلى انتباه} one {مشروع آخر يحتاج إلى انتباه} two {مشروعان آخران يحتاجان إلى انتباه} few {# مشاريع أخرى تحتاج إلى انتباه} many {# مشروعًا آخر يحتاج إلى انتباه} other {# مشروع آخر يحتاج إلى انتباه}}",
  "home.attention.allClear.title": "كل المشاريع تسير وفق الخطة",
  "home.attention.allClear.body": "{count, plural, zero {لا مشاريع جارية حاليًا.} one {مشروع جارٍ واحد، ولا شيء يستدعي المتابعة.} two {مشروعان جاريان، ولا شيء يستدعي المتابعة.} few {# مشاريع جارية، ولا شيء يستدعي المتابعة.} many {# مشروعًا جاريًا، ولا شيء يستدعي المتابعة.} other {# مشروع جارٍ، ولا شيء يستدعي المتابعة.}}",
  "home.attention.noProjects.title": "لا توجد مشاريع بعد",
  "home.attention.noProjects.body": "أنشئ مشروعًا وستظهر حالته هنا.",
  "home.attention.noProjects.memberBody": "ستظهر هنا المشاريع التي تُضاف إليها.",
  "home.workload.title": "عبء العمل على الفريق",
  "home.workload.legendOpen": "مفتوحة",
  "home.workload.legendOverdue": "متأخرة",
  "home.workload.open": "{count, plural, zero {لا مهام} one {مهمة واحدة} two {مهمتان} few {# مهام} many {# مهمة} other {# مهمة}}",
  "home.workload.overdue": "{count, plural, zero {لا تأخير} one {واحدة متأخرة} two {اثنتان متأخرتان} few {# متأخرة} many {# متأخرة} other {# متأخرة}}",
  "home.workload.dueThisWeek": "{count, plural, zero {لا شيء مستحق هذا الأسبوع} one {مهمة مستحقة هذا الأسبوع} two {مهمتان مستحقتان هذا الأسبوع} few {# مهام مستحقة هذا الأسبوع} many {# مهمة مستحقة هذا الأسبوع} other {# مهمة مستحقة هذا الأسبوع}}",
  "home.workload.empty.title": "لا مهام مفتوحة مُسندة",
  "home.workload.empty.body": "عند إسناد المهام سترى هنا حجم العمل على كل شخص.",
  "home.activity.title": "نشاط حديث",
  "home.activity.empty.title": "لا نشاط بعد",
  "home.activity.empty.body": "ستظهر هنا التغييرات على المهام والتعليقات الجديدة في مشاريعك.",
  "home.activity.showMore": "عرض المزيد",
  "home.activity.showLess": "عرض أقل",
  "myWork.intro": "{greeting}. {count, plural, zero {لا مهام مُسندة إليك الآن.} one {لديك مهمة مفتوحة واحدة.} two {لديك مهمتان مفتوحتان.} few {لديك # مهام مفتوحة.} many {لديك # مهمة مفتوحة.} other {لديك # مهمة مفتوحة.}}",
  "myWork.overdueCount": "{count, plural, zero {لا متأخرات} one {مهمة متأخرة} two {مهمتان متأخرتان} few {# مهام متأخرة} many {# مهمة متأخرة} other {# مهمة متأخرة}}",
  "myWork.loadError": "تعذّر تحميل مهامك.",
  "myWork.section.overdue": "متأخرة",
  "myWork.section.today": "اليوم",
  "myWork.section.week": "هذا الأسبوع",
  "myWork.section.later": "لاحقاً",
  "myWork.section.review": "بانتظار المراجعة",
  "myWork.section.mentions": "الإشارات",
  "myWork.mention.sentence": "{actor} ذكرك في تعليق على {target}",
  "notifications.title": "الإشعارات",
  "notifications.bellLabel": "{count, plural, zero {الإشعارات} one {الإشعارات، إشعار واحد غير مقروء} two {الإشعارات، إشعاران غير مقروءين} few {الإشعارات، # إشعارات غير مقروءة} many {الإشعارات، # إشعارًا غير مقروء} other {الإشعارات، # إشعار غير مقروء}}",
  "notifications.filterLabel": "عرض",
  "notifications.filter.all": "الكل",
  "notifications.filter.unread": "غير المقروءة",
  "notifications.markAll": "تحديد الكل كمقروء",
  "notifications.markError": "تعذّر تحديث الإشعارات. حاول مرة أخرى.",
  "notifications.loadError": "تعذّر تحميل الإشعارات.",
  "notifications.loadMore": "تحميل المزيد",
  "notifications.loadingMore": "جارٍ التحميل…",
  "notifications.empty.title": "لا إشعارات بعد",
  "notifications.empty.body": "عندما يُسند إليك أحد مهمة أو يذكرك أو يحرّك عملك إلى مرحلة جديدة، ستجد ذلك هنا.",
  "notifications.emptyUnread.title": "لا جديد",
  "notifications.emptyUnread.body": "لا إشعارات غير مقروءة. تجد الإشعارات السابقة في «الكل».",
  "notifications.unread": "غير مقروء",
  "notifications.sentence.assigned": "{actor} أسند إليك {target}",
  "notifications.sentence.mentioned": "{actor} ذكرك في تعليق على {target}",
  "notifications.sentence.commented": "{actor} علّق على {target}",
  "notifications.sentence.statusChanged": "{actor} نقل {target} إلى {status}",
  "notifications.sentence.updated": "{actor} حدّث {target}",
  "notifications.sentence.memberAdded": "{actor} أضافك إلى {target}{role, select, lead { بصفتك قائدًا للمشروع} contributor { بصفتك مساهمًا} viewer { بصفتك متابعًا} other {}}",
  "comments.title": "التعليقات والنشاط",
  "comments.label": "اكتب تعليقًا",
  "comments.placeholder": "اكتب تعليقًا… اكتب @ للإشارة إلى زميل",
  "comments.send": "إرسال",
  "comments.sendHint": "للإرسال",
  "comments.sending": "جارٍ الإرسال…",
  "comments.readOnly": "يمكنك متابعة هذه المحادثة، لكن لا يمكنك التعليق في هذا المشروع.",
  "comments.forbidden": "لا يمكنك التعليق على هذه المهمة.",
  "comments.postError": "لم يُرسَل تعليقك. أعدناه إلى خانة الكتابة لتحاول مرة أخرى.",
  "comments.editError": "لم يُحفظ تعديلك. حاول مرة أخرى.",
  "comments.loadError": "تعذّر تحميل المحادثة.",
  "comments.empty": "لا تعليقات بعد. ابدأ المحادثة من الأسفل.",
  "comments.edited": "(معدَّل)",
  "comments.deleted": "حُذف هذا التعليق.",
  "comments.actions": "خيارات التعليق",
  "comments.edit": "تعديل",
  "comments.editLabel": "عدّل تعليقك",
  "comments.save": "حفظ",
  "comments.delete": "حذف",
  "comments.deleting": "جارٍ الحذف…",
  "comments.deleteTitle": "حذف هذا التعليق؟",
  "comments.deleteBody": "سيُزال نصه لدى الجميع، وتبقى في المحادثة إشارة إلى أن تعليقًا قد حُذف.",
  "comments.by": "تعليق من {name}",
  "comments.mention.heading": "أشِر إلى زميل",
  "activity.someone": "شخص ما",
  "activity.someMember": "أحد الأعضاء",
  "activity.thisTask": "هذه المهمة",
  "activity.showEarlier": "عرض النشاط الأقدم",
  "activity.task.created": "{actor} أنشأ {target}",
  "activity.task.moved": "{actor} نقل {target} إلى {status}",
  "activity.task.assigned": "{actor} أسند {target} إلى {name}",
  "activity.task.assignedYou": "{actor} أسند {target} إليك",
  "activity.task.assignedSelf": "{actor} تولّى {target}",
  "activity.task.assignedSomeone": "{actor} أسند {target} إلى أحد الزملاء",
  "activity.task.unassigned": "{actor} ألغى إسناد {target}",
  "activity.task.unassignedPerson": "{actor} أزال {name} من {target}",
  "activity.task.unassignedYou": "{actor} أزالك من {target}",
  "activity.task.unassignedSelf": "{actor} انسحب من {target}",
  "activity.task.cancelled": "{actor} ألغى {target}",
  "activity.task.restored": "{actor} أعاد فتح {target}",
  "activity.task.updated": "{actor} حدّث {target}",
  "activity.task.renamed": "{actor} غيّر عنوان {target} إلى {title}",
  "activity.task.dueSet": "{actor} حدّد موعد تسليم {target} في {date}",
  "activity.task.dueCleared": "{actor} أزال موعد تسليم {target}",
  "activity.task.startSet": "{actor} حدّد تاريخ بدء {target} في {date}",
  "activity.task.startCleared": "{actor} أزال تاريخ بدء {target}",
  "activity.task.prioritySet": "{actor} غيّر أولوية {target} إلى {priority}",
  "activity.task.estimateChanged": "{actor} عدّل الوقت المقدّر في {target}",
  "activity.task.descriptionChanged": "{actor} حدّث وصف {target}",
  "activity.comment.created": "{actor} علّق على {target}",
  "activity.project.created": "{actor} أنشأ مشروع {target}",
  "activity.project.updated": "{actor} حدّث تفاصيل مشروع {target}",
  "activity.project.statusChanged": "{actor} غيّر حالة مشروع {target} إلى {status}",
  "activity.project.memberAdded": "{actor} أضاف {name} إلى {target}",
  "activity.project.memberAddedYou": "{actor} أضافك إلى {target}",
  "activity.project.memberRoleChanged": "{actor} جعل {name} {role, select, lead {قائدًا} contributor {مساهمًا} viewer {متابعًا} other {عضوًا}} في {target}",
  "activity.project.memberRemoved": "{actor} أزال {name} من {target}",
  "activity.project.changed": "{actor} أجرى تغييرًا في {target}",
  "search.tasks": "المهام",
  "search.clients": "العملاء",
  "search.people": "الأشخاص",
  "search.loading": "جارٍ البحث…",
  "home.portfolio.newThisWeek": "{count, plural, zero {لا جديد خلال ٧ أيام} one {مهمة جديدة خلال ٧ أيام} two {مهمتان جديدتان خلال ٧ أيام} few {# مهام جديدة خلال ٧ أيام} many {# مهمة جديدة خلال ٧ أيام} other {# مهمة جديدة خلال ٧ أيام}}",
  "home.delta.vsPrevious": "عن الأسبوع السابق",
  "home.delta.up": "{count, plural, zero {لا زيادة} one {مهمة واحدة أكثر} two {مهمتان أكثر} few {# مهام أكثر} many {# مهمة أكثر} other {# مهمة أكثر}} من الأيام السبعة السابقة",
  "home.delta.down": "{count, plural, zero {لا نقص} one {مهمة واحدة أقل} two {مهمتان أقل} few {# مهام أقل} many {# مهمة أقل} other {# مهمة أقل}} من الأيام السبعة السابقة",
  "home.delta.same": "مثل الأيام السبعة السابقة",
  "home.throughput.title": "العمل المنجز",
  "home.throughput.description": "المهام المنجزة كل أسبوع خلال آخر ٨ أسابيع",
  "home.throughput.thisWeek": "هذا الأسبوع حتى الآن",
  "home.throughput.lastWeek": "الأسبوع الماضي",
  "home.throughput.average": "المتوسط الأسبوعي",
  "home.throughput.current": "هذا الأسبوع",
  "home.throughput.weekOf": "أسبوع {date}",
  "home.throughput.tooltip": "{count, plural, zero {لم تُنجز مهام} one {أُنجزت مهمة واحدة} two {أُنجزت مهمتان} few {أُنجزت # مهام} many {أُنجزت # مهمة} other {أُنجزت # مهمة}}",
  "home.throughput.tableCaption": "المهام المنجزة كل أسبوع خلال آخر ٨ أسابيع",
  "home.throughput.columnWeek": "بداية الأسبوع",
  "home.throughput.columnDone": "المهام المنجزة",
  "home.throughput.empty": "لم تُنجز أي مهمة خلال آخر ٨ أسابيع بعد.",
  "home.status.title": "العمل المفتوح حسب الحالة",
  "home.status.description": "{count, plural, zero {لا توجد مهام مفتوحة في المشاريع النشطة} one {مهمة مفتوحة واحدة في المشاريع النشطة} two {مهمتان مفتوحتان في المشاريع النشطة} few {# مهام مفتوحة في المشاريع النشطة} many {# مهمة مفتوحة في المشاريع النشطة} other {# مهمة مفتوحة في المشاريع النشطة}}",
  "home.status.empty": "لا يوجد عمل مفتوح. ستظهر المهام الجديدة هنا عند تخطيطها.",
  "activity.file.attached": "أرفق {actor} {name} في {target}",
  "activity.file.versionAdded": "رفع {actor} الإصدار {version} من {name} في {target}",
  "activity.file.removed": "حذف {actor} {name} من {target}",
  "comments.attach": "إرفاق ملفات",
  "comments.attachHint": "أو الصق لقطة شاشة",
  "comments.attachments": "ملفات هذا التعليق",
  "comments.attachmentsBusy": "انتظر حتى يكتمل رفع الملفات.",
  "comments.removeAttachment": "إزالة {name}",
  "myWork.tabs.label": "عروض مهامي",
  "myWork.tab.assigned": "مسندة إليّ",
  "myWork.tab.review": "بانتظار مراجعتي",
  "myWork.side.label": "أسبوعك",
  "myWork.week.title": "أسبوعك",
  "myWork.week.free": "لا مواعيد",
  "myWork.week.more": "{count, plural, zero {} one {ومهمة أخرى} two {ومهمتان أخريان} few {و# مهام أخرى} many {و# مهمة أخرى} other {و# مهمة أخرى}}",
  "myWork.time.title": "وقتك هذا الأسبوع",
  "myWork.time.open": "افتح جدول الوقت",
  "myWork.empty.assigned.title": "لا مهام مسندة إليك",
  "myWork.empty.assigned.body": "عندما يسند إليك أحد مهمة ستظهر هنا مرتبة حسب موعدها.",
  "myWork.empty.review.title": "لا شيء بانتظار مراجعتك",
  "myWork.empty.review.body": "المهام التي أنشأتها تظهر هنا عندما تصل إلى المراجعة.",
  "myWork.empty.mentions.title": "لا إشارات",
  "myWork.empty.mentions.body": "عندما يشير إليك زميل في تعليق ستجده هنا.",
  "myWork.tile.none": "لا شيء",
  "home.deadlines.title": "المواعيد النهائية القادمة",
  "home.deadlines.description": "المشاريع الجارية حسب تاريخ الانتهاء",
  "home.deadlines.left": "{count, plural, zero {ينتهي اليوم} one {يتبقى يوم} two {يتبقى يومان} few {يتبقى # أيام} many {يتبقى # يومًا} other {يتبقى # يوم}}",
  "home.deadlines.late": "{count, plural, zero {متأخر} one {متأخر يومًا} two {متأخر يومين} few {متأخر # أيام} many {متأخر # يومًا} other {متأخر # يوم}}",
  "home.deadlines.empty.title": "لا مواعيد انتهاء بعد",
  "home.deadlines.empty.body": "أضف تاريخ انتهاء للمشاريع الجارية لتظهر هنا بالترتيب.",
  "notifications.sentence.approvalApproved": "تمت الموافقة على {target} من {actor}",
  "notifications.sentence.approvalChangesRequested": "طُلبت تعديلات على {target} من {actor}",
  "notifications.sentence.unblocked": "{actor} أنهى {blocker}، فأصبحت {target} جاهزة للبدء",
  "activity.task.dependencyAdded": "{actor} جعل {target} متوقفة على مهمة أخرى",
  "activity.task.dependencyRemoved": "{actor} أزال ما كانت {target} متوقفة عليه",
  "activity.task.unblocked": "لم تعد {target} متوقفة",
  "activity.task.recurrenceSet": "{actor} جعل {target} تتكرر",
  "activity.task.recurrenceStopped": "{actor} أوقف تكرار {target}",
  "activity.task.labelsChanged": "{actor} غيّر تصنيفات {target}",
  "activity.task.milestoneChanged": "{actor} غيّر محطة {target}",
  "activity.task.phaseChanged": "{actor} غيّر مرحلة {target}",
  "activity.milestone.created": "{actor} أضاف المحطة {target}",
  "activity.milestone.updated": "{actor} عدّل المحطة {target}",
  "activity.milestone.completed": "{actor} أعلن تحقق المحطة {target}",
  "activity.milestone.reopened": "{actor} أعاد فتح المحطة {target}",
  "activity.milestone.deleted": "{actor} حذف المحطة {target}",
  "activity.milestone.phasesAdded": "{actor} أضاف {count, plural, zero {# مرحلة} one {مرحلة واحدة} two {مرحلتين} few {# مراحل} many {# مرحلة} other {# مرحلة}} إلى {target}",
  "activity.phase.created": "{actor} أضاف المرحلة {name} إلى {target}",
  "activity.phase.updated": "{actor} عدّل المرحلة {name} في {target}",
  "activity.phase.deleted": "{actor} حذف المرحلة {name} من {target}"
}
